import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './edit-delivery-option-page.module.less';
import { fullWeek } from '../../../../../../constants/date-format';
import { PickupSettingsDayPropType } from '../../../../../../prop-types/pickup-settings-day';
import { createLookupHash } from '../../../../../../services/hash-service';
import StartThroughClosingTime from '../../../../components/start-through-closing-time';
import scheduleMessages from '../../../../ship-from-locations/messages';
import messages from '../../messages';

const PickupSettingsSchedule = ({ defaultShipFromId, pickupDays = null, shipFromTimeZone = '' }) => {
  if (pickupDays) {
    const isConsecutiveDays = fullWeek.join('').includes(pickupDays.map((day) => day.day).join('')) && pickupDays.length > 1;
    const userDefinedWorkdayMap = createLookupHash(pickupDays, 'day');
    const { day: firstDay, startTime: firstStartTime, endTime: firstEndTime } = pickupDays[0];
    const { day: lastDay } = pickupDays[pickupDays.length - 1];
    const isSameSchedule = pickupDays.reduce(
      (isSame, day) => isSame && day.startTime === firstStartTime && day.endTime === firstEndTime,
      true,
    );
    const fullWeekSchedule = fullWeek.map((day) => ({
      name: day,
      formattedName: <FormattedMessage {...scheduleMessages[day]} />,
      isClosed: !userDefinedWorkdayMap[day],
      startThroughEndTime: userDefinedWorkdayMap[day] ? (
        <StartThroughClosingTime {...userDefinedWorkdayMap[day]} />
      ) : (
        <FormattedMessage {...messages.closed} />
      ),
    }));
    const closedDaySchedule = fullWeekSchedule.filter(({ isClosed }) => isClosed);

    return (
      <>
        <div className={style['pickup-settings-schedule']}>
          {isSameSchedule && isConsecutiveDays ? (
            <>
              <div>
                <FormattedMessage {...scheduleMessages[firstDay]} />
                -
                <FormattedMessage {...scheduleMessages[lastDay]} />
              </div>
              <StartThroughClosingTime endTime={firstEndTime} startTime={firstStartTime} />
              {closedDaySchedule.map((day) => (
                <>
                  <div>{day.formattedName}</div>
                  <div>{day.startThroughEndTime}</div>
                </>
              ))}
            </>
          ) : (
            fullWeekSchedule.map((day) => (
              <>
                <div>{day.formattedName}</div>
                <div>{day.startThroughEndTime}</div>
              </>
            ))
          )}
        </div>
        <div className={style['pickup-settings-schedule-timezone']}>
          <FormattedMessage
            {...messages.pickupTimeZoneNote}
            values={{
              timezone: shipFromTimeZone,
              a: (chunk) => <Link to={`/settings/warehouses/${defaultShipFromId}/pickup-settings`}>{chunk}</Link>,
            }}
          />
        </div>
      </>
    );
  }
  return (
    <BannerMessageV2
      content={
        <>
          <FormattedMessage {...messages.checkoutDisplayAvailabilityNotDefined} />
          <div>
            <Link to={`/settings/warehouses/${defaultShipFromId}/pickup-settings`}>
              <FormattedMessage {...messages.addAvailabileHours} />
            </Link>
          </div>
        </>
      }
      status={BannerStatus.Error}
    />
  );
};

PickupSettingsSchedule.propTypes = {
  defaultShipFromId: PropTypes.string.isRequired,
  pickupDays: PropTypes.arrayOf(PickupSettingsDayPropType),
  shipFromTimeZone: PropTypes.string,
};

export default PickupSettingsSchedule;
